import React, { useState, useEffect } from "react";
import TopNavigation from "../../../components/TopNavigation";
import ResultContent from "../ResultContent";
import EmptyData from "../../../components/EmptyDataScreen";
import CardIcon from "../CardIcon";
import moment from "moment";
import * as Assets from "../../../utils/svg_assets";
import * as PageRoutes from "../../../utils/route_pages";
import { connect } from "react-redux";
import { Base } from "../../../components/RootLayout";
import { useParams, useNavigate } from "react-router-dom";
import "./style.scss";

const PollingResult = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const { getPollingResult, postLikePolling } = props;
  const [pollingResult, setPollingResult] = useState({});
  const [result, setResult] = useState([]);
  const [isModal, setIsModal] = useState(false);
  const [isValidateModal, setIsValidateModal] = useState(false);

  const dataIcon = [
    {
      icon: Assets.iconLikeSolid,
      count: pollingResult?.total_like,
    },
    {
      icon: Assets.iconCommentSolid,
      count: pollingResult?.survey_comments?.length,
    },
    {
      icon: Assets.iconView,
      count: pollingResult?.total_view,
    },
  ];

  const processDataResult = (data) => {
    let dataResult = data?.result[0];
    let dataState = data?.survey_object;
    dataState.your_answer = dataResult?.your_answer;
    let result = Object.values(dataResult?.answers_stat);
    for (let i = 0; i < result.length; i++) {
      dataState.questions[0].options[i].result = result[i];
      setPollingResult(dataState);
    }
  };

  const getData = async () => {
    const { data, status } = await getPollingResult(params.pollingId);
    if (status == 200) {
      processDataResult(data);
    } else {
      setPollingResult({});
      navigate(PageRoutes.polling);
    }
  };

  const handleClickLike = async () => {
    let dataPost = {
      data: {
        survey: params.pollingId,
      },
    };
    const { status } = await postLikePolling(dataPost);
    if (status == 200) {
      getData();
    }
  };

  const handleClickComment = () => {
    navigate(PageRoutes.polling + `/${params.pollingId}/result/comments`);
  };

  useEffect(() => {
    getData();
  }, []);

  props = {
    ...props,
    result,
    setResult,
    isModal,
    setIsModal,
    isValidateModal,
    setIsValidateModal,
    data: pollingResult.questions,
  };

  return (
    <Base>
      <TopNavigation
        titlePage="Polling"
        toPath={PageRoutes.polling}
        setBorder={true}
        showRightIcon={false}
        iconLeft={Assets.iconBack}
        iconRight={Assets.iconFilter}
      />
      <div className="polling-result-content">
        {pollingResult.id ? (
          <>
            <div className="content-header">
              <span className="polling-about">
                Polling about {pollingResult?.read_topics[0]?.name}
              </span>
              <div className="title-wrapper">
                <span className="polling-title">{pollingResult?.name}</span>
              </div>
              <span className="polling-creator">
                Posted by {pollingResult?.creator},{" "}
                {moment(pollingResult?.start).format("DD MMM YYYY")}
              </span>
              <div className="polling-info">
                {dataIcon &&
                  dataIcon.map((a, index) => (
                    <CardIcon key={index} icon={a.icon} count={a.count} />
                  ))}
              </div>
              <div className="polling-point">
                <img src={Assets.iconGoldCoin} alt="logo_image" />
                <div className="point-wrapper">
                  <span className="point">
                    Get {pollingResult?.points} {pollingResult?.currency?.name}
                  </span>
                </div>
              </div>
            </div>
            <hr />
            <div className="content-body">
              {pollingResult?.questions &&
                pollingResult?.questions.map((a, index) => (
                  <div className="result-content-wrapper" key={index}>
                    <span className="title">{a?.title}</span>
                    {a?.options &&
                      a?.options.map((b, indexOptions) => (
                        <ResultContent
                          key={indexOptions}
                          isChoosedAnswer={
                            pollingResult.your_answer == b.option ? true : false
                          }
                          answer={b.option}
                          percentage={b.result}
                        />
                      ))}
                  </div>
                ))}
            </div>
            <div className="content-footer">
              <div className="btn action-button" onClick={handleClickLike}>
                <div className="img-wrapper">
                  <img src={Assets.iconLikeSolid} alt="iconLikeSolid" />
                </div>
                <span className="text">Like</span>
              </div>
              <div
                className="btn border-gray action-button"
                onClick={handleClickComment}
              >
                <div className="img-wrapper">
                  <img src={Assets.iconCommentSolid} alt="iconCommentSolid" />
                </div>
                <span className="text">Comment</span>
              </div>
            </div>
          </>
        ) : (
          <div className="no-poll-wrapper">
            <EmptyData
              title="There is no poll"
              image={`${process.env.PUBLIC_URL + "/SKOR-Quiz-NoQuiz.png"}`}
              imageStyle={{ width: "170px" }}
              bottomText="Stay tuned for more polls"
            />
          </div>
        )}
      </div>
    </Base>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  getPollingResult: dispatch.PollingSM.getPollingResult,
  postLikePolling: dispatch.PollingSM.postLikePolling,
});

export default connect(mapStateToProps, mapDispatchToProps)(PollingResult);
